import { mergeClasses, OverflowItem, Tab } from "@fluentui/react-components";
import CloseIcon from "~icons/material-symbols/close";

import { memo } from "react";
import { useTabItemStyles } from "../styles/TabItem.styles";

type TabItemProps = {
  tab: { id: string; name: string };
  isSelected: boolean;
  priority?: number;
  onClose: (id: string) => void;
};

export const TabItem = memo(({ tab, isSelected, priority, onClose }: TabItemProps) => {
  const styles = useTabItemStyles();

  return (
    <OverflowItem id={tab.id} priority={priority}>
      <Tab
        className={mergeClasses(styles.tab, styles.tabPseudo, isSelected ? styles.selectedTab : "")}
        value={tab.id}
        icon={<CloseIcon className="text-[16px]" onClick={(_ev) => onClose(tab.id)} />}
      >
        <span className={styles.tabItem} title={tab.name}>
          {tab.name}
        </span>
      </Tab>
    </OverflowItem>
  );
});
